import React, { Fragment, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { GoogleOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import qs from 'qs';
import { useGoogleSignIn } from '../../../../../hooks/useAuth';
import { AuthLayout } from '../../../components/Layout';

export const SignInGoogle = () => {
    const navigate = useNavigate();
    const { redirect, processCode, error } = useGoogleSignIn();

    useEffect(() => {
        const queryParams = qs.parse(window.location.search, { ignoreQueryPrefix: true });
        if (queryParams.code) {
            processCode.mutate(queryParams.code);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const loading = redirect.isPending || processCode.isPending;

    return (
        <AuthLayout
            error={error}
            heading='Welcome back'
            subheading='Use your Klickly Google account to continue to the admin.'
            footer={
                <span className='auth-secondary'>
                    Trouble signing in?{' '}
                    <Button type='link' onClick={() => navigate('/sign-in/manual')}>
                        Use email & password
                    </Button>
                </span>
            }
        >
            <Fragment>
                <Button
                    onClick={() => redirect.mutate()}
                    size='large'
                    icon={<GoogleOutlined aria-hidden='true' />}
                    type='primary'
                    htmlType='submit'
                    loading={loading}
                    className='login-form-button'
                    block
                >
                    Sign in with Google
                </Button>
            </Fragment>
        </AuthLayout>
    );
};
